import React from 'react';
import {
    Group,
    Badge,
    GenericSkeleton,
    BadgeVariant,
    BadgeKind,
    BadgeSize,
} from '@landr/maestro';
import styled from 'styled-components';

const UppercaseBadge = styled(Badge)`
    text-transform: uppercase;
    max-width: 100%;

    > span {
        text-overflow: ellipsis;
        display: block;
        overflow: hidden;
    }
`;

const Wrapper = styled(Group.Item)`
    overflow: hidden;
`;

const getBadges = ({
    metasDisplayName,
    isLoading = false,
    variant,
    kind,
    size,
}: {
    metasDisplayName?: string[];
    isLoading?: boolean;
    variant: BadgeVariant;
    kind: BadgeKind;
    size: BadgeSize;
}) => {
    if (isLoading) {
        return (
            <>
                <Group.Item key="skeleton-badge-1">
                    <GenericSkeleton width="73px" height="24px" />
                </Group.Item>
                <Group.Item key="skeleton-badge-2">
                    <GenericSkeleton width="51px" height="24px" />
                </Group.Item>
                <Group.Item key="skeleton-badge-3">
                    <GenericSkeleton width="66px" height="24px" />
                </Group.Item>
            </>
        );
    }

    const badges = metasDisplayName?.map((tag) => (
        <Wrapper key={tag}>
            <UppercaseBadge
                content={tag}
                variant={variant}
                kind={kind}
                size={size}
            />
        </Wrapper>
    ));

    return badges;
};

export default getBadges;
